export const GET_MEMES = 'GET_MEMES';
export const SET_LOADING = 'SET_LOADING';
export const SET_MEME = 'SET_MEME';
export const SET_URL = 'SET_URL';